import React from "react";
import AppLayout from "../components/app-layoout";
import { Stack, Typography, Box } from "@mui/material";

import { LayoutContainer } from "../components/app-layoout/container";
import StarIcon from "../components/icons/StarIcon";
import RegisterYourPropertyForm from "../components/Form/RegisterYourPropertyForm";

const RegisterYourProperty = () => {
  return (
    <AppLayout>
      <Stack py="100px">
        <LayoutContainer>
          <Stack mb={3}>
            <Box mb={2}>
              <StarIcon />
            </Box>
            <Typography variant="h3" color="text.secondary" mb={2}>
              Registra tu propiedad
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.primary"
              width={{ xs: "100%", md: "60%" }}
              mb={5}
            >
              Nos entusiasma conectar con usted y conocer mejor sus objetivos
              inmobiliarios. Utilice el formulario a continuación para contactar
              con Plusvalica Estate. Ya sea un cliente potencial, un socio o
              simplemente tenga curiosidad sobre nuestros servicios, estamos
              aquí para responder a sus preguntas y brindarle la asistencia que
              necesita.
            </Typography>
          </Stack>
          <RegisterYourPropertyForm />
        </LayoutContainer>
      </Stack>
    </AppLayout>
  );
};

export default RegisterYourProperty;
